import webrtcSupport from './WebRTCSupport';
import utils from '../../utils';
import LocalMedia from './LocalMedia';
import Peer from './Peer';
import ctor from './ctor';

const WildEmitter = utils.WildEmitter;

function WebRTC(opts) {
    const that = this;
    this.config = {
        debug: false,
        // makes the entire PC config overridable
        peerConnectionConfig: {
            iceServers: [{'urls': 'stun:stun.l.google.com:19302'}]
        },
        peerConnectionConstraints: {
            optional: []
        },
        receiveMedia: {
            offerToReceiveAudio: 1,
            offerToReceiveVideo: 1
        },
        enableDataChannels: true
    };
  
    ctor.call(this, "WebRTC", opts);

    if (!webrtcSupport.support) {
        this.logger.error('Your browser doesn\'t seem to support WebRTC');
    }

    this.peers = [];
    this.localMedia = new LocalMedia(opts);

    ['start', 'stop', 'mute', 'unmute', 'pauseVideo', 'resumeVideo', 'pause', 'resume','isAudioEnabled','isVideoEnabled']
    .forEach(function (method) {
        that[method] = that.localMedia[method].bind(that.localMedia);
    });
    
    // proxy events from LocalMedia
    this.localMedia.on('*', function () {
        that.emit.apply(that, arguments);
    });

    this.localMedia.on('speaking', function () {
        if (!that.hardMuted) {
            // FIXME: should use sendDirectlyToAll, but currently has different semantics wrt payload
            that.peers.forEach(function (peer) {
                if (peer.enableDataChannels) {
                    var dc = peer.getDataChannel('hark');
                    if (dc.readyState != 'open') return;
                    dc.send(JSON.stringify({type: 'speaking'}));
                }
            });
        }
    });
    this.localMedia.on('stoppedSpeaking', function () {
        if (!that.hardMuted) {
            // FIXME: should use sendDirectlyToAll, but currently has different semantics wrt payload
            that.peers.forEach(function (peer) {
                if (peer.enableDataChannels) {
                    var dc = peer.getDataChannel('hark');
                    if (dc.readyState != 'open') return;
                    dc.send(JSON.stringify({type: 'stoppedSpeaking'}));
                }
            });
        }
    });
    this.localMedia.on('volumeChange', function (volume/*, treshold*/) {
        if (!that.hardMuted) {
            // FIXME: should use sendDirectlyToAll, but currently has different semantics wrt payload
            that.peers.forEach(function (peer) {
                if (peer.enableDataChannels) {
                    var dc = peer.getDataChannel('hark');
                    if (dc.readyState != 'open') return;
                    dc.send(JSON.stringify({type: 'volume', volume: volume }));
                }
            });
        }
    });
}

WildEmitter.mixin(WebRTC);

Object.defineProperty(WebRTC.prototype, "localScreens", {
    configurable: false,
    enumerable: true,
    get() {
        return this.localMedia.localScreens;
    }
});

Object.defineProperty(WebRTC.prototype, "localStreams", {
    configurable: false,
    enumerable: true,
    get() {
        return this.localMedia.localStreams;
    }
});

WebRTC.prototype.createPeer = function (opts) {
    var peer;
    opts.parent = this;
    peer = new Peer(opts);
    this.peers.push(peer);
    return peer;
};

// removes peers
WebRTC.prototype.removePeers = function (id, type) {
    this.getPeers(id, type).forEach(function (peer) {
        peer.end();
    });
};

// fetches all Peer objects by session id and/or type
WebRTC.prototype.getPeers = function (sessionId, type) {
    return this.peers.filter(function (peer) {
        return (!sessionId || peer.id === sessionId) && (!type || peer.type === type);
    });
};

// sends message to all
WebRTC.prototype.sendToAll = function (message, payload) {
    this.peers.forEach(function (peer) {
        peer.send(message, payload);
    });
};

// sends message to all using a datachannel
// only sends to anyone who has an open datachannel
WebRTC.prototype.sendDirectlyToAll = function (channel, message, payload) {
    this.peers.forEach(function (peer) {
        if (peer.enableDataChannels) {
            peer.sendDirectly(channel, message, payload);
        }
    });
};

export default WebRTC;
